import { render, staticRenderFns } from "./LeasePlanForm.vue?vue&type=template&id=28a8b244&scoped=true"
import script from "./LeasePlanForm.vue?vue&type=script&lang=js"
export * from "./LeasePlanForm.vue?vue&type=script&lang=js"
import style0 from "./LeasePlanForm.vue?vue&type=style&index=0&id=28a8b244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a8b244",
  null
  
)

export default component.exports